// Reading the server's error bodies. Kept apart from the axios client so
// pages (and tests that mock the client) can use it freely.

/** The body of a 403 the server returns when a tenant permission doesn't allow an action. */
export interface PermissionDeniedBody {
  error: string;
  code: 'permission_denied';
  permission: string;
}

export function isPermissionDenied(err: any): boolean {
  return err?.response?.status === 403 && err?.response?.data?.code === 'permission_denied';
}

/**
 * A refusal the upgrade dialog already explains: a feature the plan doesn't
 * include (403 plan_upgrade_required) or a used-up allowance (429). A page
 * that catches one shouldn't show its own error on top of the dialog.
 */
export function isPlanLimitRefusal(err: any): boolean {
  const status = err?.response?.status;
  const code = err?.response?.data?.code ?? err?.response?.data?.error;
  return (status === 403 && code === 'plan_upgrade_required')
    || (status === 429 && (code === 'ai_allowance_exceeded' || code === 'transcript_limit_reached'));
}

/** The server's own explanation when it gave one (`{ error }`), else the fallback. */
export function apiErrorMessage(err: any, fallback: string): string {
  const message = err?.response?.data?.error;
  return typeof message === 'string' && message.trim() ? message : fallback;
}
